import { render, staticRenderFns } from "./OutsourceDrushimCities.vue?vue&type=template&id=2c7b6e72&scoped=true"
import script from "./OutsourceDrushimCities.vue?vue&type=script&lang=js"
export * from "./OutsourceDrushimCities.vue?vue&type=script&lang=js"
import style0 from "./OutsourceDrushimCities.vue?vue&type=style&index=0&id=2c7b6e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b6e72",
  null
  
)

export default component.exports